import { useCallback } from 'react'

import { useAuth } from '@/features/auth/authContext'
import { resolveTerm } from '@/lib/brand/resolveTerm'
import type { Term, TermKey } from '@/types/workspace'

/** A label that is either fixed text or one of the company's words. */
export type TermLabel = string | { term: TermKey; form: 'singular' | 'plural' }

export function useTerm(key: TermKey): Term {
  const { workspace } = useAuth()
  return resolveTerm(workspace, key)
}

/** For module-level constants (nav items, route titles) that cannot call a hook themselves. */
export function useTermLabel(): (label: TermLabel) => string {
  const { workspace } = useAuth()
  return useCallback(
    (label: TermLabel) =>
      typeof label === 'string' ? label : resolveTerm(workspace, label.term)[label.form],
    [workspace],
  )
}
